import React, { useState } from "react";
import { Modal } from "antd";
import { outboundCall } from "../apis/callingAPis";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useAuth } from "../context/authContext";

const OutboundModal = ({
  isoutboundModalOpen,
  showoutboundModal,
  showcallModal,
}) => {
  const { username, email, customerId, agenid } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showform, setshowform] = useState(false);
  const [success, setSuccess] = useState(false);

  const validationSchema = yup.object({
    phone: yup
      .string()
      .matches(/^\d{10,15}$/, "Phone number must be between 10 and 15 digits") // Add this validation for full phone number
      .required("Phone number is required"),
  });

  const formik = useFormik({
    initialValues: {
      phone: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const res = await outboundCall(
          values.phone,
          customerId,
          agenid,
          username,
          email
        );

        formik.resetForm();
        setSuccess(true);
      } catch (err) {
        console.error(err || "An unexpected error occurred");
        formik.resetForm();
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Modal
        open={isoutboundModalOpen}
        onCancel={() => {
          showoutboundModal();
          setshowform(false);
          setSuccess(false);
        }}
        centered
        footer={null}
        className="white-payment-modal"
      >
        {!success && (
          <>
            {!showform && (
              <>
                <div className="head">
                  <h5 className="card-label">Select where to call agent</h5>
                </div>

                <div className="agent-buttons">
                  <button
                    className="cursor-pointer btn-primary"
                    onClick={showcallModal}
                  >
                    Proceed here
                  </button>
                  <button
                    className="cursor-pointer btn-primary"
                    onClick={() => setshowform(true)}
                  >
                    Call on phone number
                  </button>
                </div>
              </>
            )}
            {showform && (
              <>
                <div className="head">
                  <h5 className="card-label">Fill the field to call</h5>
                </div>
                <form onSubmit={formik.handleSubmit} className="log-form">
                  <div className="input-wrap">
                    <label>Phone Number:</label>
                    <PhoneInput
                      inputProps={{
                        id: "phone",
                        name: "phone",
                      }}
                      country={"us"}
                      onChange={(phone) => formik.setFieldValue("phone", phone)}
                      onBlur={formik.handleBlur}
                      value={formik.values.phone}
                      inputClass="phone-input"
                    />
                    {formik.touched.phone && formik.errors.phone && (
                      <div className="text-red ">{formik.errors.phone}</div>
                    )}
                  </div>

                  <button
                    className="cursor-pointer btn-primary"
                    disabled={loading}
                    type="submit"
                  >
                    {loading ? "Loading..." : "Continue"}
                  </button>
                </form>
              </>
            )}{" "}
          </>
        )}
        {success && (
          <>
            <div className="head">
              <h5 className="card-label">Call started successfully</h5>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default OutboundModal;
